import React from 'react';
import { Box, Typography } from '@mui/material';
import { useGame } from '../../context/GameContext';

const actionButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  borderRadius: '6px',
  backgroundColor: 'action.hover',
  cursor: 'pointer',
};

const ObjectContextMenu = () => {
  const {
    objectContextMenuPosition: position,
    objectContextMenuObject,
    onContextMenuRotate: onRotate,
    onContextMenuDelete: onDelete,
  } = useGame();

  if (!position || !objectContextMenuObject) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        left: position.x,
        top: position.y,
        display: 'flex',
        gap: 1,
        zIndex: 10000,
        backgroundColor: 'background.paper',
        borderRadius: '8px',
        padding: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        border: '2px solid',
        borderColor: 'primary.main',
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <Box
        sx={{
          ...actionButtonStyles,
          '&:hover': {
            backgroundColor: 'action.selected',
          },
        }}
        onClick={onRotate}
      >
        <Typography sx={{ fontFamily: 'MedievalSharp', fontSize: '1.2rem' }}>
          ↻
        </Typography>
      </Box>
      <Box
        sx={{
          ...actionButtonStyles,
          '&:hover': {
            backgroundColor: 'error.dark',
            color: 'error.contrastText',
          },
        }}
        onClick={onDelete}
      >
        <Typography sx={{ fontFamily: 'MedievalSharp', fontSize: '0.9rem' }}>
          ✕
        </Typography>
      </Box>
    </Box>
  );
};

export default ObjectContextMenu;
